import React, { Fragment } from "react";
import { Navigate } from "react-router-dom";

export const ProtectedRoute = ({ authData, children }) => {
  return (
    <div>
      {authData.isLogin ? (
        <Fragment>{children}</Fragment>
      ) : (
        <Navigate to="/login" replace />
      )}
    </div>
  );
};
